const beforeAfterCases = [
  {
    src: "/images/ba_face_lifting.jpeg",
    alt: "Face lifting and skin tightening - Before and After",
    treatment: "Face Lifting & Skin Tightening",
    area: "Full Face",
    sessions: "3 Sessions",
    type: "image",
  },
  {
    src: "/images/ba_stretch_marks.jpeg",
    alt: "Stretch marks reduction - Before and After",
    treatment: "Stretch Marks Reduction",
    area: "Body",
    sessions: "4 Sessions",
    type: "image",
  },
  {
    src: "/images/ba_jawline.jpeg",
    alt: "Jawline tightening and wrinkle reduction - Before and After",
    treatment: "Jawline Definition & Tightening",
    area: "Lower Face & Neck",
    sessions: "3 Sessions",
    type: "image",
  },
  {
    src: "/images/ba_male_face.jpeg",
    alt: "Male face rejuvenation and skin tightening - Before and After",
    treatment: "Skin Rejuvenation & Lifting",
    area: "Full Face",
    sessions: "3 Sessions",
    type: "image",
  },
  {
    src: "/images/ba_male_profile.jpeg",
    alt: "Male profile skin tightening and neck lift - Before and After",
    treatment: "Neck Lift & Skin Tightening",
    area: "Profile & Neck",
    sessions: "3 Sessions",
    type: "image",
  },
];

const beforeAfterVideos = [
  {
    src: "/images/ba_video1.mp4",
    treatment: "Treatment Results Video",
    type: "video",
  },
  {
    src: "/images/ba_video2.mp4",
    treatment: "Clinical Results Video",
    type: "video",
  },
];

const treatmentOutcomes = [
  { label: "Wrinkle Reduction", percent: 100 },
  { label: "Skin Tightening", percent: 100 },
  { label: "Face Lifting", percent: 65 },
  { label: "Texture Improvement", percent: 85 },
];

function BeforeAfterCard({ item, index, large }) {
  return (
    <div
      className={`group relative overflow-hidden bg-[#141418] border border-white/6 transition-all duration-500 hover:border-[#D4AF37]/20 ${large ? "" : ""}`}
      data-testid={`ba-card-${index}`}
    >
      {/* Image */}
      <div className={`relative overflow-hidden ${large ? "aspect-[4/3]" : "aspect-[16/10]"}`}>
        <img
          src={item.src}
          alt={item.alt}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          style={{ imageRendering: "auto" }}
        />
        {/* Before / After Labels */}
        <div className="absolute top-3 left-3 flex gap-1.5">
          <span
            className="px-2.5 py-1 text-[9px] tracking-[0.15em] uppercase bg-white/10 backdrop-blur-md text-white/80 border border-white/10"
            style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
          >
            Before
          </span>
          <span
            className="px-2.5 py-1 text-[9px] tracking-[0.15em] uppercase bg-[#D4AF37]/20 backdrop-blur-md text-[#D4AF37] border border-[#D4AF37]/20"
            style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
          >
            After
          </span>
        </div>
      </div>

      {/* Info */}
      <div className="p-5">
        <h4
          className="text-base font-light text-white mb-2"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {item.treatment}
        </h4>
        <div className="flex items-center gap-3">
          <span className="text-[10px] tracking-[0.1em] uppercase text-white/30" style={{ fontFamily: "'Manrope', sans-serif" }}>
            {item.area}
          </span>
          <span className="w-1 h-1 rounded-full bg-white/15" />
          <span className="text-[10px] tracking-[0.1em] uppercase text-[#D4AF37]/60" style={{ fontFamily: "'Manrope', sans-serif" }}>
            {item.sessions}
          </span>
        </div>
      </div>
    </div>
  );
}

export default function BeforeAfterGallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 lg:py-32 px-6 lg:px-12"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="reveal mb-16">
          <p
            className="text-xs tracking-[0.3em] uppercase mb-4"
            style={{ color: "#D4AF37", fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
          >
            Before & After Results
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-white leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Real Patients.<br />
            <span className="text-white/40">Real Results.</span>
          </h2>
        </div>

        {/* Before/After Grid - Top Row */}
        <div className="grid md:grid-cols-12 gap-4 mb-4 reveal">
          <div className="md:col-span-7">
            <BeforeAfterCard item={beforeAfterCases[0]} index={0} large />
          </div>
          <div className="md:col-span-5">
            <BeforeAfterCard item={beforeAfterCases[1]} index={1} large />
          </div>
        </div>

        {/* Before/After Grid - Middle Row */}
        <div className="grid md:grid-cols-3 gap-4 mb-4 reveal">
          <BeforeAfterCard item={beforeAfterCases[2]} index={2} />
          <BeforeAfterCard item={beforeAfterCases[3]} index={3} />
          <BeforeAfterCard item={beforeAfterCases[4]} index={4} />
        </div>

        {/* Video Results Row */}
        <div className="grid md:grid-cols-2 gap-4 mb-4 reveal">
          {beforeAfterVideos.map((video, i) => (
            <div
              key={i}
              className="group relative overflow-hidden bg-[#141418] border border-white/6 transition-all duration-500 hover:border-[#D4AF37]/20"
              data-testid={`ba-video-${i}`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <video
                  src={video.src}
                  className="w-full h-full object-cover"
                  controls
                  muted
                  playsInline
                  preload="metadata"
                />
                <div className="absolute top-3 left-3 pointer-events-none">
                  <span
                    className="px-2.5 py-1 text-[9px] tracking-[0.15em] uppercase bg-[#D4AF37]/20 backdrop-blur-md text-[#D4AF37] border border-[#D4AF37]/20"
                    style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
                  >
                    Video
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h4
                  className="text-base font-light text-white"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {video.treatment}
                </h4>
              </div>
            </div>
          ))}
        </div>

        {/* Outcomes Panel */}
        <div className="reveal mt-12 glass-card p-8 lg:p-12" data-testid="outcomes-panel">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <p
                className="text-xs tracking-[0.2em] uppercase mb-6"
                style={{ color: "#D4AF37", fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
              >
                Patient Outcome Rates
              </p>
              <div className="space-y-5">
                {treatmentOutcomes.map((outcome) => (
                  <div key={outcome.label}>
                    <div className="flex justify-between items-baseline mb-2">
                      <span className="text-sm text-white/60" style={{ fontFamily: "'Manrope', sans-serif" }}>
                        {outcome.label}
                      </span>
                      <span
                        className="text-lg text-white font-light"
                        style={{ fontFamily: "'Cormorant Garamond', serif" }}
                      >
                        {outcome.percent}%
                      </span>
                    </div>
                    <div className="h-[2px] bg-white/10 w-full">
                      <div
                        className="h-full transition-all duration-1000 ease-out"
                        style={{
                          width: `${outcome.percent}%`,
                          backgroundColor: "#D4AF37",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="space-y-4">
              <p
                className="text-base text-white/50 leading-relaxed"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                Results from the multicenter clinical trial demonstrate consistent improvement
                across diverse patient profiles — including both Caucasian and Asian skin types
                (Fitzpatrick II–IV). Treatments were well-tolerated with minimal downtime.
              </p>
              <p className="text-xs text-white/25" style={{ fontFamily: "'Manrope', sans-serif" }}>
                * Individual results may vary. Images are from actual Cami X treatments.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
